import { normalizeToLocalDate } from '@shared/utils/format-date/formatDate';

import type { BalanceStatus } from '../../api/types/balance-status.types';
import type { DraftFilterState } from './InvoicesFilterPanel.types';

export const BALANCE_STATUS_OPTIONS: { id: BalanceStatus; name: string }[] = [
  { id: 'Paid', name: 'Paid' },
  { id: 'Unpaid', name: 'Unpaid' },
  { id: 'FullCredit', name: 'Full credit' },
];

export const EMPTY_DRAFT: DraftFilterState = {
  dueDateStart: null,
  dueDateEnd: null,
  issuedDateStart: null,
  issuedDateEnd: null,
  balanceStatuses: [],
  currencies: [],
  platforms: [],
  locations: [],
};

export function toggleItem<T extends string>(arr: T[], item: T): T[] {
  return arr.includes(item) ? arr.filter(v => v !== item) : [...arr, item];
}

export function toCheckboxOptions(values: string[]): { id: string; name: string }[] {
  return values.map(v => ({ id: v, name: v }));
}

export function toIsoDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function dateRangeToValue(
  start: string | null,
  end: string | null
): [Date, Date] | null {
  if (!start || !end) return null;
  return [normalizeToLocalDate(start), normalizeToLocalDate(end)];
}

export function areArraysEqual(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort((x, y) => x.localeCompare(y));
  const sortedB = [...b].sort((x, y) => x.localeCompare(y));
  return sortedA.every((value, index) => value === sortedB[index]);
}

export function isDraftDirty(
  draft: DraftFilterState,
  applied: DraftFilterState
): boolean {
  return (
    draft.dueDateStart !== applied.dueDateStart ||
    draft.dueDateEnd !== applied.dueDateEnd ||
    draft.issuedDateStart !== applied.issuedDateStart ||
    draft.issuedDateEnd !== applied.issuedDateEnd ||
    !areArraysEqual(
      draft.balanceStatuses as string[],
      applied.balanceStatuses as string[]
    ) ||
    !areArraysEqual(draft.currencies, applied.currencies) ||
    !areArraysEqual(draft.platforms, applied.platforms) ||
    !areArraysEqual(draft.locations, applied.locations)
  );
}

export function isDraftEmpty(draft: DraftFilterState): boolean {
  return (
    draft.dueDateStart === null &&
    draft.dueDateEnd === null &&
    draft.issuedDateStart === null &&
    draft.issuedDateEnd === null &&
    draft.balanceStatuses.length === 0 &&
    draft.currencies.length === 0 &&
    draft.platforms.length === 0 &&
    draft.locations.length === 0
  );
}
